import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x27fkb4h4a: FaireBrandEntity = {
  token: "b_x27fkb4h4a",
  type: "brand",
  name: "Paige Tate & Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/c4fcb815adc959dff4a2b7fd0a1f3e840e5f48ffb73a7838fadb35e305013461.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/edebad40f7846b01faecafc714660afb796ef560a5b2a28f5755dc5383f50518.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c4fcb815adc959dff4a2b7fd0a1f3e840e5f48ffb73a7838fadb35e305013461.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/edebad40f7846b01faecafc714660afb796ef560a5b2a28f5755dc5383f50518.jpeg",
  location: "Bend, OR, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 225,
  isTopShop: true,
  isInsider: true,
  description:
    "Paige Tate & Co. is a lifestyle brand that empowers readers to live their lives fully and intentionally. We are much more than what meets the eye. While we strive to create books that are outwardly beautiful, our ultimate goal is to pair beauty with content that elevates the lives of our customers – each of our books embody the ideal of function + beauty.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:41.305Z",
    importedBy: "entity-db-cli",
  },
};
